import { Alert, Link, spacing } from '@digitools/honest-ui';
import React, { useEffect, useState, useMemo } from 'react';
import styled from 'styled-components';
import { Language } from '../../types/Language';
import axios from 'axios';
import useExperience from '../../hooks/useExperience';
const StyledAlerts = styled('div') `
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
  margin-top: ${spacing.md};
  margin-bottom: ${spacing.md};
  &:empty {
    margin: 0;
  }
`;
export var FunctionalArea;
(function (FunctionalArea) {
    FunctionalArea["LOGIN"] = "LOGIN";
    FunctionalArea["EMPLOYEE_LANDING"] = "EMPLOYEE_LANDING";
    FunctionalArea["EMPLOYER_LANDING"] = "EMPLOYER_LANDING";
    FunctionalArea["USAA_MOBILE"] = "USAA_MOBILE";
    FunctionalArea["MULTI_CUSTOMER_LANDING"] = "MULTI_CUSTOMER_LANDING";
    FunctionalArea["COVERAGE_DETAILS"] = "COVERAGE_DETAILS";
    FunctionalArea["CLI"] = "CLI";
    FunctionalArea["RIA"] = "RIA";
    FunctionalArea["AS"] = "AS";
    FunctionalArea["EOI"] = "EOI";
})(FunctionalArea || (FunctionalArea = {}));
/**
 * Paired with functionality on the notification admin-ui to parse messages with embedded links
 * to format them into an honest link correctly. Non fully qualified links will route keeping
 * the base url (to link within the app)
 *
 * Format: <http://www.test.com[Click Here!]>
 *
 * @param rawMessage
 */
const parseMessageForLinks = (rawMessage) => {
    const regex = /<(.*?)\[.*?\]>/;
    if (rawMessage.search(regex) < 0) {
        return rawMessage;
    }
    else {
        const linkToken = rawMessage.substring(rawMessage.indexOf('<') + 1, rawMessage.indexOf('>'));
        const textBefore = rawMessage.substring(0, rawMessage.indexOf('<'));
        let textAfter = rawMessage.substring(rawMessage.indexOf('>') + 1);
        const url = linkToken.substring(0, linkToken.indexOf('['));
        const title = linkToken.substring(linkToken.indexOf('[') + 1, linkToken.indexOf(']'));
        if (textAfter) {
            textAfter = parseMessageForLinks(textAfter);
        }
        // Fully qualified urls leave the app, so they render as external anchors; everything
        // else keeps the base url and routes client-side, per the format documented above.
        const linkType = /^https?:\/\//i.test(url) ? 'external' : 'local';
        return (<>{textBefore}<Link data-testid='notification-link' href={url} linkType={linkType}>{title}</Link>{textAfter}</>);
    }
};
const Notifications = ({ functionalArea }) => {
    const [notifications, setNotifications] = useState([]);
    const { language } = useExperience();
    useEffect(() => {
        fetchActiveNotifications();
    }, []);
    const fetchActiveNotifications = async () => {
        const url = `/mlp-ui-service/services/v1/notifications/active?functionalArea=${functionalArea}`;
        try {
            const response = await axios.get(url);
            setNotifications(response.data);
        }
        catch (error) {
            console.error(error);
        }
    };
    const alerts = useMemo(() => {
        let alerts = [];
        if (notifications && !Array.isArray(notifications)) {
            console.error('Notifications returned as an unknown type, the app is not accessed correctly and/or is recieving invalid data');
        }
        if (notifications && Array.isArray(notifications) && notifications?.length > 0) {
            notifications.forEach(notification => {
                alerts.push(<Alert key={notification.id} type={notification.severity.toLowerCase()} dismissible={true} heading={language === Language.SPANISH ? notification.titleES : notification.titleEN}>
            {language === Language.SPANISH ? parseMessageForLinks(notification.msgES) : parseMessageForLinks(notification.msgEN)}
          </Alert>);
            });
        }
        return alerts;
    }, [notifications, language]);
    return (<StyledAlerts data-public={true}>
      {alerts}
    </StyledAlerts>);
};
export default Notifications;
